import { Component } from '@angular/core';
import { PaMessageComponent } from 'src/app/shared/ui-kit/pa-message/pa-message.component';

@Component({
  selector: 'app-message-view',
  standalone: true,
  imports: [PaMessageComponent],
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.scss'],
})
export class MessageViewComponent {}
